export default __webpack_public_path__ + "images/2b38227988d432ec25c6c2fbbe95f1c1.jpeg";